import { concat, reject } from 'es-toolkit/compat';

import { SharedAppConstants } from '@tock/shared-app-constants';
import { core, toJSON, toJSONArray } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface PaymentCardState {
  cards: core.PaymentCard[];
  deviceData?: string;
  isInitialized: boolean;
  insertRequestInProgress: boolean;
  listRequestInProgress: boolean;
  tokenizeRequestInProgress: boolean;
}

export const initialState = {
  cards: [],
  deviceData: undefined,
  isInitialized: false,
  insertRequestInProgress: false,
  listRequestInProgress: false,
  tokenizeRequestInProgress: false,
};

export default function reducer(
  state: PaymentCardState = initialState,
  action: BaseTockAction
): PaymentCardState {
  const { type, payload, context } = action;
  switch (type) {
    // Payment card states
    case SharedAppConstants.PAYMENT_CARD_FETCH_STARTING:
    case SharedAppConstants.PAYMENT_CARD_DELETE_STARTING:
      return {
        ...state,
        listRequestInProgress: true,
      };
    case SharedAppConstants.PAYMENT_CARD_INSERT_STARTING:
      return {
        ...state,
        insertRequestInProgress: true,
      };
    case SharedAppConstants.PAYMENT_CARD_TOKENIZE_STARTING:
      return {
        ...state,
        tokenizeRequestInProgress: true,
      };

    case SharedAppConstants.PAYMENT_CARD_FETCH_DONE:
      return {
        ...state,
        cards: toJSONArray<core.PaymentCard>(payload),
        isInitialized: true,
        listRequestInProgress: false,
      };

    case SharedAppConstants.PAYMENT_CARD_INSERT_DONE: {
      const newCard = toJSON<core.PaymentCard>(payload);
      const cards = state.cards;

      return {
        ...state,
        cards: concat(cards, newCard),
        insertRequestInProgress: false,
      };
    }
    case SharedAppConstants.PAYMENT_CARD_DELETE_DONE: {
      const cards = state.cards;
      const removedCard = context.paymentCard;
      return {
        ...state,
        listRequestInProgress: false,
        cards: reject(cards, (card) => card.storedToken === removedCard.storedToken),
      };
    }

    case SharedAppConstants.PAYMENT_CARD_TOKENIZE_DONE:
    case SharedAppConstants.PAYMENT_CARD_TOKENIZE_FAILED:
      return {
        ...state,
        tokenizeRequestInProgress: false,
      };
    case SharedAppConstants.PAYMENT_CARD_INSERT_FAILED:
      return {
        ...state,
        insertRequestInProgress: false,
      };
    case SharedAppConstants.PAYMENT_CARD_DELETE_FAILED:
    case SharedAppConstants.PAYMENT_CARD_FETCH_FAILED:
      return {
        ...state,
        listRequestInProgress: false,
      };

    case SharedAppConstants.PAYMENT_CARD_DEVICE_DATA:
      return {
        ...state,
        deviceData: payload,
      };

    // Clear states
    case AppConstants.AUTHENTICATION_CLEARED_DONE:
    case AppConstants.AUTHENTICATION_RESPONSE_DONE:
    case AppConstants.CREATE_ACCOUNT_DONE: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
}
